const AVATAR_GRADIENTS = [
  'from-sky-500 to-indigo-600',
  'from-emerald-500 to-cyan-600',
  'from-amber-500 to-orange-600',
  'from-fuchsia-500 to-rose-600',
  'from-blue-500 to-violet-600',
  'from-teal-500 to-blue-600',
  'from-lime-500 to-emerald-600',
  'from-pink-500 to-red-600',
] as const

const FALLBACK_INITIALS = '??'

function normalizeAvatarText(value?: string | null): string {
  return String(value || '').replace(/^\*+/, '').trim()
}

function hashText(value: string): number {
  let hash = 2166136261
  for (const ch of value) {
    hash ^= ch.codePointAt(0) || 0
    hash = Math.imul(hash, 16777619)
  }
  return hash >>> 0
}

function getFirstLetter(value: string): string {
  const first = [...value][0]
  return first ? first.toUpperCase() : ''
}

export function getAvatarInitials(value?: string | null): string {
  const cleaned = normalizeAvatarText(value)
  if (!cleaned) return FALLBACK_INITIALS

  const words = cleaned.split(/\s+/).filter(Boolean)
  if (words.length >= 2) {
    const combined = `${getFirstLetter(words[0])}${getFirstLetter(words[1])}`
    if (combined.length === 2) return combined
    if (combined.length === 1) return `${combined}${combined}`
  }

  const letters = [...words[0]].filter((ch) => /[\p{L}\p{N}]/u.test(ch))
  if (letters.length >= 2) return `${letters[0].toUpperCase()}${letters[1].toUpperCase()}`
  if (letters.length === 1) return `${letters[0].toUpperCase()}${letters[0].toUpperCase()}`
  return FALLBACK_INITIALS
}

export function getAvatarGradientClass(seedText?: string | null, loadSeed?: number): string {
  const seed = `${normalizeAvatarText(seedText)}|${String(loadSeed ?? Date.now())}`
  const index = hashText(seed) % AVATAR_GRADIENTS.length
  return AVATAR_GRADIENTS[index]
}
